export const ROLE_NAMES = {
  Manager: 'Manager',
  SuperAdmin: 'SuperAdmin',
  Broker: 'Broker',
  Trainer: 'Trainer',
  Employee: 'Employee'
}